import { TextField, Button, Input } from "@material-ui/core";
import Auth from "../../Auth";
import React, { useState } from "react";
import LoginWrapper from "./LoginWr";
import { setToken } from "../../API";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FormPage = (props) => {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");

  const checkAuth = async () => {
    let result = await setToken({ phoneNumber: name, password: password });
    if (!result.error) {
      localStorage.setItem("login", true);
      localStorage.setItem("token", result.data.objectKoinot.accessToken);
      Auth.login(() => {
        props.history.push("/koinot/create");
      });
    } else {
      toast.error("Parol yoki Username xato", { theme: "dark" });
    }
  };
  const submitHandler = (e) => {
    e.preventDefault();
    checkAuth();
  };
  return (
    <LoginWrapper>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        toastStyle={{ backgroundColor: "#171717" }}
      />
      <form className="rounded" onSubmit={submitHandler}>
        <div>
          <h3>Sign In</h3> <br />
          <div className="form-group mb-4">
            <TextField
              type="text"
              variant="filled"
              className="w-100"
              label="Your Phone Number"
              value={name}
              onChange={(e) => setName(e.target.value)}
              InputLabelProps={{ className: "inputlabel" }}
            />
          </div>
          <div className="form-group mb-4">
            <TextField
              type="password"
              variant="filled"
              className="w-100"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputLabelProps={{ className: "inputlabel" }}
            />
          </div>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="w-100"
          >
            Submit
          </Button>
        </div>
      </form>
    </LoginWrapper>
  );
};
export default FormPage;



// WEBPACK FOOTER //
// ./src/Pages/Login/index.js